/* eslint-disable @typescript-eslint/no-explicit-any */
import { IonSpinner } from '@ionic/react';
import * as Sentry from '@sentry/react';
import React, { useCallback } from 'react';
// import { DefaultGenerics, StreamChat as TStreamChat } from 'stream-chat';
// import { type Channel as TChannel } from 'stream-chat/dist/types/channel';
// import { type Message } from 'stream-chat/dist/types/types';
// import {
//   Channel,
//   Chat,
//   defaultRenderMessages,
//   MessageInput,
//   MessageList,
//   MessageRenderer,
//   Window,
// } from 'stream-chat-react';

import { BaseProps } from '@/types/props';

import { VERSION } from '@/environments/version';
import { CenteredContent } from '@/pages/common/layouts.styles';

// import TerraiMessageUI from '@/components/@ionic/stream-chat/TerraiMessageUI';
import TypingIndicator from '@/components/@ionic/stream-chat/TypingIndicator';

import S from './StreamChat.styles';

interface Props extends BaseProps {
  client: any; // TStreamChat<DefaultGenerics> | null;
  channel: any; // TChannel<DefaultGenerics> | null;
  isLoading: boolean;
  isMessageListHidden?: boolean;
  isMessageInputHidden?: boolean;
  isMessageInputDisabled?: boolean;
  BeforeMessageListSlot?: React.JSX.Element;
  AfterMessageListSlot?: React.JSX.Element;
  theme?: 'light' | 'dark';
}

const StreamChat: React.FC<Props> = ({
  client,
  channel,
  isLoading,
  isMessageListHidden = false,
  isMessageInputHidden = false,
  isMessageInputDisabled = false,
  BeforeMessageListSlot,
  AfterMessageListSlot,
  theme = 'light',
  ...baseProps
}) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const doSendMessageRequest = useCallback(
    async (cbChannel: any, message: any) => {
      const activeSpan = Sentry.getActiveSpan();
      const rootSpan = activeSpan ? Sentry.getRootSpan(activeSpan) : undefined;

      // Create `sentry-trace` header
      const sentryTrace = rootSpan ? Sentry.spanToTraceHeader(rootSpan) : undefined;

      // Create `baggage` header
      const sentryBaggage = rootSpan ? Sentry.spanToBaggageHeader(rootSpan) : undefined;

      const modifiedMessage = {
        ...message,
        sentryTrace,
        sentryBaggage,
        terrai_env: VERSION.subenv,
      };

      // Send the message via Stream Chat
      return cbChannel.sendMessage(modifiedMessage);
    },
    []
  );

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const renderMessages = useCallback(
    (options: any) => {
      // const renderedMessages = defaultRenderMessages(options);
      const renderedMessages: any[] = [];

      if (BeforeMessageListSlot) {
        renderedMessages.unshift(<li key="BeforeMessageListSlot">{BeforeMessageListSlot}</li>);
      }

      if (AfterMessageListSlot) {
        renderedMessages.push(<li key="AfterMessageListSlot">{AfterMessageListSlot}</li>);
      }

      renderedMessages.push(
        <li key="TypingIndicator">
          <TypingIndicator key="TypingIndicator" />
        </li>
      );

      return renderedMessages;
    },
    [BeforeMessageListSlot, AfterMessageListSlot]
  );

  if (isLoading || !client || !channel) {
    return (
      <CenteredContent>
        <IonSpinner name="circular" />
      </CenteredContent>
    );
  }

  // Stream chat components are not available
  return (
    <S.Container {...baseProps}>
      <CenteredContent>
        <div style={{ padding: '20px', textAlign: 'center' }}>
          <p>Chat functionality is temporarily unavailable.</p>
          <p>Stream Chat integration has been disabled.</p>
        </div>
      </CenteredContent>
    </S.Container>
  );
};

export default StreamChat;
